<template>
  <q-page padding>
    <div class="row col-12">
      <p class="text-h6 text-brand-5 text-weight-bold">
        Criar Nova Tranferência de Posição
      </p>
    </div>

    <section class="row">
      <div class="q-mt-sm col-md-2">
        <lista-unidades-select v-model="unidade"></lista-unidades-select>
      </div>
      <div class="col-md-2 col-2 q-mt-sm q-ml-sm">
        <q-input dense outlined label="Posição" v-model="posicao" />
      </div>
      <div class="q-mt-sm col-md-2 q-ml-sm">
        <q-input dense outlined label="Produto" v-model="produto" />
      </div>
    </section>

    <div class="q-pt-md q-mt-lg">
      <q-table
        flat
        table-header-class="bg-accent text-width-bold"
        title="Selecione os produtos se quiser transferir entre posições"
        :rows="rows"
        :columns="columns"
        class="tabela-tamanho-fixo"
        dense
        :loading="disable"
        v-model:pagination="pagination"
        hide-pagination
        @request="handleRequest"
      >
        <template #body-cell-delete="props">
          <q-td>
            <q-btn
              @click="deleteId(props.row.id)"
              color="negative"
              round
              icon="delete"
            />
          </q-td>
        </template>
        <template #body-cell-selecione="props">
          <q-td>
            <q-checkbox v-model="selecionados" :val="props.row" />
          </q-td>
        </template>
        <template #body-cell-contract_product_description="props">
          <q-td
            style="
              white-space: normal;
              word-break: break-word;
              max-width: 300px;
            "
          >
            <span>{{ props.row.contract_product_description }}</span>
          </q-td>
        </template>
      </q-table>
      <div class="row justify-start q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>

    <div class="row justify-around">
      <section style="width: 60%">
        <selecionados
          :data="selecionados"
          :transferir="atualizar"
          @selecionadosRows="receberSelecionados"
        />
        <q-btn
          class="q-mt-md"
          style="width: 100%"
          @click="criarMovimentacao"
          label="
            CRIAR MOVIMENTAÇÂO DE LOCALIZAÇÃO
          "
          color="positive"
          icon="add"
        />
      </section>
      <section style="width: 37%">
        <destino
          :atualizarDestino="atualizarDestino"
          @destino="receberDestino"
        />
      </section>
    </div>
  </q-page>
</template>

<script>
const columns = [
  {
    name: "selecione",
    label: "Selecionar",
    field: "selecione",
    align: "left",
  },
  {
    name: "codigo",
    label: "Codigo",
    field: "codigo",
    align: "left",
  },
  {
    name: "contract_product_description",
    label: "Descrição",
    field: "contract_product_description",
    align: "left",
  },
  {
    name: "localizacao",
    label: "Localização",
    field: "localizacao",
    align: "left",
  },
  {
    name: "quantidade",
    label: "Qtd. em Estoque",
    field: "quantidade",
    align: "left",
  },
  {
    name: "valor_unitario",
    label: "Vlr Unitário",
    field: "valor_unitario",
    align: "left",
  },
  {
    name: "total",
    label: "Total",
    field: "total",
    align: "left",
  },
];

import { ref, onMounted, watch, computed } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import Selecionados from "../components/Selecionados.vue";
import Destino from "../components/Destino.vue";
import ListaUnidadesSelect from "../../../organizacional/unidade/component/ListaUnidadesSelect.vue";

export default {
  components: { Selecionados, Destino, ListaUnidadesSelect },
  setup() {
    const store = useStore();
    const $q = useQuasar();
    const posicao = ref();
    const produto = ref();
    const rows = ref([]);
    const destinoId = ref([]);
    const atualizar = ref(0);
    const atualizarDestino = ref(0);
    const selecionadoDados = ref([]);
    const selecionados = ref([]);
    const disable = ref(true);
    const unidade = ref();
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 10,
    });

    const getDados = async (page = 1, rowsPerPage = 10) => {
      disable.value = true;
      try {
        const response = await store.dispatch("estoque/getProdutos", {
          vendor_id: store.state.org.unidadeData.id,
          localizacao: posicao.value,
          produto: produto.value,
          perPage: rowsPerPage,
          page,
        });

        rows.value = response.data.data;

        pagination.value.rowsPerPage = response.data.per_page;
        pagination.value.rowsNumber = response.data.total;
        pagination.value.page = response.data.current_page;
        disable.value = false;
      } catch (error) {
        disable.value = false;
        $q.notify({
          message: "Erro a o encontrar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getDados);

    const deleteId = async (id) => {
      try {
        await store.dispatch("estoque/deletarPosicao", {
          id: id,
        });

        $q.notify({
          message: "Deletado com sucesso!",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getDados();
      } catch (error) {
        $q.notify({
          message: "Erro a o deletar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const movimentar = async () => {
      let produtos = [];
      selecionados.value.forEach((e) => {
        produtos.push({
          id: e.produto_id,
          localizacao_saida_id: e.localizacao_id,
          localizacao_entrada_id: destinoId.value,
          quantidade: e.destino,
        });
      });

      try {
        await store.dispatch("estoque/movimentar", {
          produtos,
        });

        $q.notify({
          message: "Movimentado com sucesso!",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });

        selecionados.value = [];
        atualizarDestino.value++;
        await getDados(pagination.value.page, pagination.value.rowsPerPage);
      } catch (error) {
        $q.notify({
          message: "Erro a o movimentar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const receberDestino = async (destino) => {
      destinoId.value = destino;
    };

    const receberSelecionados = async (selecionado) => {
      selecionadoDados.value = selecionado;
      movimentar();
    };

    const handleRequest = async () => {
      getDados(pagination.value.page, pagination.value.rowsPerPage);
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        getDados();
      }
    );
    watch(
      () => produto.value,
      () => {
        getDados();
      }
    );
    watch(
      () => posicao.value,
      () => {
        getDados();
      }
    );

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        unidade.value = JSON.parse(getunidade);
      }
    };

    onMounted(getUnidade);

    const criarMovimentacao = async () => {
      try {
        atualizar.value++;
      } catch (error) {
        console.log(error);
      }
    };

    return {
      produto,
      posicao,
      rows,
      atualizarDestino,
      disable,
      columns,
      getDados,
      deleteId,
      selecionados,
      movimentar,
      receberDestino,
      destinoId,
      receberSelecionados,
      selecionadoDados,
      atualizar,
      pagination,
      unidade,
      handleRequest,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      criarMovimentacao,
    };
  },
};
</script>

<style></style>
